export default __webpack_public_path__ + "static/media/Estrella.0b4ab61d.jpg";